import React, { useState } from 'react';
import {
  View, Text, StyleSheet, FlexStyle, Pressable,
} from 'react-native';
import InfoIcon16 from '../../../components/16pxIcons/InfoIcon16';
import DateLabel from '../../../components/Occupancy/DateLabel';
import Colors from '../../../constants/Colors';
import { DateRange } from '../../../redux/dateRangeSlice';
import isMobile from '../../../components/IsMobile';
import { PressableState } from '../../../components/PressableStyled';
import Style from '../../../constants/Style';

interface WidgetHeaderProps {
  title: string,
  range: DateRange,
  compareRange?: DateRange,
  comparisonHidden?: boolean,
  style?: FlexStyle | FlexStyle[],
  tooltipText?: string,
}

const WidgetHeader = ({
  title, range, compareRange, style, tooltipText, comparisonHidden,
}: WidgetHeaderProps) => {
  const [tooltipIconHovered, setTooltipIconHovered] = useState<boolean>(false);
  const [tooltipHovered, setTooltipHovered] = useState<boolean>(false);
  const tooltipShown: boolean = tooltipHovered || tooltipIconHovered;

  return <View style={[styles.container, style]}>
    <View style={styles.content}>
      <Text style={styles.title}>{title}</Text>
      {!isMobile && !!tooltipText && <View>
        <Pressable
          onHoverIn={() => setTooltipIconHovered(true)}
          onHoverOut={() => setTooltipIconHovered(false)}
          style={({ hovered }: PressableState) => hovered && Style.hovered}
        >
          <InfoIcon16 />
        </Pressable>
        <View
          onPointerEnter={() => setTooltipHovered(true)}
          onPointerLeave={() => setTooltipHovered(false)}
          style={styles.tooltipContainer}
        >
          {tooltipShown && <View style={styles.tooltipBox}>
            <Text style={styles.tooltipText}>
              {tooltipText}
            </Text>
          </View>}
        </View>
      </View>}
    </View>
    <DateLabel {...{ range, compareRange, comparisonHidden }} />
  </View>;
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
    zIndex: 20,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 2,
  },
  title: {
    fontFamily: 'Poppins_400Regular',
    fontSize: 18,
    lineHeight: 27,
    letterSpacing: 0,
    color: Colors.light.hereworksBlack600,
    marginEnd: 10,
  },
  tooltipContainer: {
    paddingStart: 20,
    height: '100%',
    position: 'absolute',
  },
  tooltipBox: {
    borderRadius: 5,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: '#FFF',
    width: 231,
    minHeight: 36,
    marginTop: -16,
  },
  tooltipText: {
    fontSize: 12,
    lineHeight: 18,
    fontFamily: 'Poppins_500Medium',
    letterSpacing: 0.15,
    color: Colors.light.hereworksBlue400,
  },
});

export default WidgetHeader;
